export const MOD_SUBMODULO = { mod_sub_modulo: 34 }
